/** Fetch investing backend JSON (port 5001 via /api/investing proxy). */

export async function fetchInvestingJson(path) {
  const res = await fetch(path);
  const text = await res.text();
  const trimmed = text.trimStart();
  if (trimmed.startsWith('<!') || trimmed.startsWith('<html')) {
    throw new Error(
      'Investing API returned HTML instead of JSON. Restart python backend.py on port 5001.',
    );
  }
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error('Investing API returned invalid JSON');
  }
  return { res, data };
}

/** Map GET /stock-screen payload to fundamentals row shape. */
export function fundamentalsRowsFromStockScreen(payload) {
  const prof = Array.isArray(payload?.profitability) ? payload.profitability : [];
  const val = payload?.valuation;
  if (!prof.length) return [];

  return prof.map((row, index) => {
    const out = { fiscal_year: row.fiscal_year, ...row };
    const attachVal = val && index === prof.length - 1;
    if (attachVal) {
      out.pe = val.pe ?? null;
      out.pb = val.pb ?? null;
      out.p_cf = val.p_cf ?? null;
      out.p_fcf = val.p_fcf ?? null;
      out.ev_to_sales = val.ev_to_sales ?? null;
      out.market_cap = val.market_cap ?? null;
      out.enterprise_value = val.enterprise_value ?? null;
    }
    return out;
  });
}
